import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { Types as UserTypes, getUserSuccess, getUserFailure } from './actions';

import { getUser, editUser } from '~/services/api';
import Tracking from '~/config/tracking';
import { transFormErrorResponse } from '../utils';

export const selectorToken = state => state.auth.token;

export function* getUserData() {
  try {
    const token = yield select(selectorToken);
    const response = yield call(getUser, token);
    yield put(getUserSuccess(response.data));
  } catch (err) {
    yield put(getUserFailure());
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export function* editUserData(payload) {
  try {
    const response = yield call(editUser, payload.payload);
    yield put(getUserSuccess(response.data));
    toast.success('Editado con éxito');
  } catch (err) {
    Tracking.trackApiError(transFormErrorResponse(err), { showAs: 'toast' });
  }
}

export default all([
  takeLatest(UserTypes.GET_USER_REQUEST, getUserData),
  takeLatest(UserTypes.EDIT_USER_REQUEST, editUserData),
]);
